(function() {
  var scrollTimer;
  var isScrolling = false;

  function closeDropdowns() {
    document.querySelectorAll('[data-nav-item][aria-expanded="true"]').forEach(function(el) {
      // 1. Dispatch mouseleave so Palo Alto's JS handler fires
      el.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true, cancelable: true }));
      // 2. Force-set aria-expanded in case the event was ignored
      el.setAttribute('aria-expanded', 'false');
    });
  }

  function onScroll() {
    if (!isScrolling) {
      isScrolling = true;
      closeDropdowns();
      // CSS kill-switch: hides all open dropdowns via stylesheet while scrolling
      document.documentElement.classList.add('ys-nav-scrolling');
    }
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() {
      isScrolling = false;
      // Close one more time as scroll settles, then lift the CSS override
      closeDropdowns();
      document.documentElement.classList.remove('ys-nav-scrolling');
    }, 250);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('DOMContentLoaded', function() {
    var pc = document.getElementById('PageContainer');
    if (pc) pc.addEventListener('scroll', onScroll, { passive: true });
  });
})();
